import { Spinner } from "@veritrellis/ui";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminMe } from "../hooks/useAdminMe.js";

export const RequireAuth = () => {
  const location = useLocation();
  const me = useAdminMe();
  if (me.isLoading) {
    return (
      <div className="admin-auth-loading">
        <Spinner />
      </div>
    );
  }
  if (me.isError) {
    const next = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }
  return <Outlet />;
};
